'use client';

import { c as _c } from "react/compiler-runtime";
import { cn } from '@achra/ui/lib/utils';
import { usePricingCalculatorContext } from '@/modules/service-purchase/providers/pricing-calculator-provider';
import { useHoveredTier } from '@/modules/service-purchase/providers/service-purchase-store-provider';
import type { FeatureValue, ServiceMetric } from '@/modules/service-purchase/types';
import { ServiceCatalogCell } from '../service-catalog-cell';
import { useServiceCatalogEnabled } from '../service-catalog-context';
import { MetricRow } from './metric-row';
interface FeatureRowProps {
  label: string;
  sublabel?: string;
  values: Record<string, FeatureValue>;
  metrics?: ServiceMetric[];
}
function FeatureRow(t0) {
  const $ = _c(38);
  const {
    label,
    values,
    metrics
  } = t0;
  const {
    activePlan,
    tierNames
  } = usePricingCalculatorContext();
  const hoveredPlan = useHoveredTier();
  const isGroupEnabled = useServiceCatalogEnabled();
  const hasMetrics = metrics && metrics.length > 0;
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = cn("group/row min-h-full items-center", "grid grid-cols-2 lg:grid-cols-(--grid-cols-lg) xl:grid-cols-(--grid-cols-xl)");
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  const t2 = `4fr repeat(${tierNames.length}, minmax(144px, 1fr))`;
  const t3 = `4fr repeat(${tierNames.length}, minmax(220px, 1fr))`;
  let t4;
  if ($[1] !== t2 || $[2] !== t3) {
    t4 = {
      "--grid-cols-lg": t2,
      "--grid-cols-xl": t3
    };
    $[1] = t2;
    $[2] = t3;
    $[3] = t4;
  } else {
    t4 = $[3];
  }
  const t5 = t4 as React.CSSProperties;
  let t6;
  if ($[4] === Symbol.for("react.memo_cache_sentinel")) {
    t6 = cn("border-input bg-background flex min-h-14 flex-col justify-center gap-0.5 border-b px-4 lg:px-6", "sticky left-0 z-10 lg:static");
    $[4] = t6;
  } else {
    t6 = $[4];
  }
  const t7 = isGroupEnabled ? "text-foreground" : "text-foreground/50";
  let t8;
  if ($[5] !== t7) {
    t8 = cn("text-sm font-normal", t7);
    $[5] = t7;
    $[6] = t8;
  } else {
    t8 = $[6];
  }
  let t9;
  if ($[7] !== label || $[8] !== t8) {
    t9 = <div className={t6}><div className="flex flex-col md:flex-row md:items-center md:gap-1"><span className={t8}>{label}</span></div></div>;
    $[7] = label;
    $[8] = t8;
    $[9] = t9;
  } else {
    t9 = $[9];
  }
  const t10 = !!activePlan && "bg-primary/10 font-bold";
  let t11;
  if ($[10] !== t10) {
    t11 = cn("border-input flex h-14 min-h-full min-w-0 items-center justify-center border-b px-4 transition-colors lg:hidden", t10);
    $[10] = t10;
    $[11] = t11;
  } else {
    t11 = $[11];
  }
  const t12 = values[activePlan ?? ""];
  const t13 = !!activePlan;
  let t14;
  if ($[12] !== t12 || $[13] !== t13) {
    t14 = <ServiceCatalogCell value={t12} isActive={t13} />;
    $[12] = t12;
    $[13] = t13;
    $[14] = t14;
  } else {
    t14 = $[14];
  }
  let t15;
  if ($[15] !== t11 || $[16] !== t14) {
    t15 = <div className={t11}>{t14}</div>;
    $[15] = t11;
    $[16] = t14;
    $[17] = t15;
  } else {
    t15 = $[17];
  }
  let t16;
  if ($[18] !== activePlan || $[19] !== hoveredPlan || $[20] !== tierNames || $[21] !== values) {
    let t17;
    if ($[23] !== activePlan || $[24] !== hoveredPlan || $[25] !== values) {
      t17 = plan => <div key={plan} className={cn("border-input hidden h-14 min-h-full min-w-0 items-center justify-center border-b px-6 transition-colors lg:flex", activePlan === plan && "bg-primary/10 font-bold", hoveredPlan === plan && activePlan !== plan && "bg-accent/80")}><ServiceCatalogCell value={values[plan]} isActive={activePlan === plan} /></div>;
      $[23] = activePlan;
      $[24] = hoveredPlan;
      $[25] = values;
      $[26] = t17;
    } else {
      t17 = $[26];
    }
    t16 = tierNames.map(t17);
    $[18] = activePlan;
    $[19] = hoveredPlan;
    $[20] = tierNames;
    $[21] = values;
    $[22] = t16;
  } else {
    t16 = $[22];
  }
  let t17;
  if ($[27] !== t15 || $[28] !== t16 || $[29] !== t5 || $[30] !== t9) {
    t17 = <div className={t1} style={t5}>{t9}{t15}{t16}</div>;
    $[27] = t15;
    $[28] = t16;
    $[29] = t5;
    $[30] = t9;
    $[31] = t17;
  } else {
    t17 = $[31];
  }
  let t18;
  if ($[32] !== hasMetrics || $[33] !== metrics) {
    t18 = hasMetrics && metrics.map((m, i) => <MetricRow key={m.metric} label={m.metric} values={m.values} isLast={i === metrics.length - 1} isOneTime={m.isOneTime} />);
    $[32] = hasMetrics;
    $[33] = metrics;
    $[34] = t18;
  } else {
    t18 = $[34];
  }
  let t19;
  if ($[35] !== t17 || $[36] !== t18) {
    t19 = <>{t17}{t18}</>;
    $[35] = t17;
    $[36] = t18;
    $[37] = t19;
  } else {
    t19 = $[37];
  }
  return t19;
}
export { FeatureRow };